import { useState, useEffect } from "react";
import { Receipt, ArrowUpRight, ArrowDownLeft, Gift, Crown, Shield, Coins, Zap, RefreshCw } from "lucide-react";
import api from "../../lib/api";

const TYPE_CONFIG = {
  deposit:          { icon: ArrowDownLeft, color: "#10b981", label: "Reîncărcare",     sign: "+" },
  voucher_redeem:   { icon: Gift,          color: "#8b5cf6", label: "Voucher",          sign: "+" },
  service_purchase: { icon: Crown,         color: "#f59e0b", label: "Cumpărătură VIP",  sign: "-" },
  admin_grant:      { icon: Shield,        color: "#3b82f6", label: "Credit Admin",     sign: "+" },
  p2p_send:         { icon: ArrowUpRight,  color: "#ef4444", label: "Transfer trimis",  sign: "-" },
  p2p_receive:      { icon: ArrowDownLeft, color: "#10b981", label: "Transfer primit",  sign: "+" },
};

function fmtDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  return d.toLocaleDateString("ro-RO", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
}

export default function TransactionHistory({ onClose }) {
  const [txs, setTxs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    setLoading(true);
    api.get("/wallet/transactions")
      .then(r => setTxs(r.data || []))
      .catch(() => setTxs([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          <Receipt className="w-4 h-4 text-zinc-400" />
          <span className="text-xs font-chakra font-black uppercase tracking-widest text-zinc-400">Istoric Tranzacții</span>
        </div>
        <button onClick={load} className="text-zinc-500 hover:text-white transition-colors">
          <RefreshCw className="w-3.5 h-3.5" />
        </button>
      </div>

      {loading ? (
        <div className="flex justify-center py-8 text-zinc-500">
          <RefreshCw className="w-5 h-5 animate-spin" />
        </div>
      ) : txs.length === 0 ? (
        <div className="text-center py-8 text-zinc-600 font-mono text-xs">
          <Coins className="w-8 h-8 mx-auto mb-2 opacity-30" />
          Nicio tranzacție înregistrată.
        </div>
      ) : (
        <div className="space-y-1.5 max-h-64 overflow-y-auto custom-scrollbar pr-1">
          {txs.map((tx, i) => {
            const cfg = TYPE_CONFIG[tx.type] || { icon: Zap, color: "#71717a", label: tx.type, sign: "+" };
            const Icon = cfg.icon;
            const isPos = cfg.sign === "+";

            return (
              <div key={tx.id || i} className="flex items-center gap-3 p-2.5 rounded-lg bg-white/[0.02] border border-white/5 hover:border-white/10 transition-all">
                <div className="w-7 h-7 rounded-lg flex items-center justify-center shrink-0"
                  style={{ background: `${cfg.color}15`, border: `1px solid ${cfg.color}25` }}>
                  <Icon className="w-3.5 h-3.5" style={{ color: cfg.color }} />
                </div>
                <div className="flex-1 min-w-0">
                  <div className="text-xs font-chakra font-bold text-white truncate">{cfg.label}</div>
                  <div className="text-[10px] text-zinc-500 font-mono truncate">{tx.description}</div>
                </div>
                <div className="shrink-0 text-right">
                  <div className={`font-mono text-sm font-black ${isPos ? "text-emerald-400" : "text-rose-400"}`}>
                    {cfg.sign}{Math.abs(tx.amount_coins).toLocaleString()}
                  </div>
                  <div className="text-[9px] text-zinc-600 font-mono">{fmtDate(tx.created_at)}</div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
